@if (patients && patients.length === 0) {
	@if (showTasksCompletedState) {
		<empty-state icon="fa fa-star" [animated]="true" [message]="'general.tasks_done' | translate" />
	} @else {
		<empty-state icon="fa fa-search" [message]="'home.empty_state' | translate" />
	}
}

@if (patients && patients.length === 0) {
	<empty-state
		[animated]="showTasksCompletedState"
		[icon]="showTasksCompletedState ? 'fa fa-star' : 'fa fa-search'"
		[message]="(showTasksCompletedState ? 'general.tasks_done' : 'home.empty_state') | translate"
	/>
}

<sorted-list-view data-test="resident-list" [items]="patients" [key]="['name', 'firstName']">
	<ng-template let-patient>
		<patient-item
			data-test="resident-list-item"
			[class.no_tasks]="!patient.openTaskCodes?.length"
			[name]="patient.fullName"
			[picture]="patient.picture | profilePicture"
			[present]="patient.status === 'P'"
			[residentId]="patient.id"
			(click)="selectedPatient.next(patient)"
		/>
	</ng-template>
</sorted-list-view>
